<div class="text-center">
  <h1 class="h5 text-uppercase">{{ 'auth.password.reset.heading' | translate }}</h1>
</div>

<div class="row mt-2">
  <app-form-group
    [formControl]="form.controls.password"
    type="password"
    name="password"
    label="{{ 'auth.password.reset.form.password.label' | translate }}"
    [errorMessages]="{required: ('auth.password.reset.form.password.validation_messages.required' | translate)}"
  ></app-form-group>
</div>

<div class="row mt-2">
  <app-form-group
    [formControl]="form.controls.password_confirmation"
    type="password"
    name="password_confirmation"
    label="{{ 'auth.password.reset.form.password_confirmation.label' | translate }}"
    [errorMessages]="{required: ('auth.password.reset.form.password_confirmation.validation_messages.required' | translate)}"
  ></app-form-group>
</div>

<div class="row mt-3">
  <div class="col-12">
    <button (click)="submit()" type="submit" class="btn btn-primary w-100">{{ 'auth.password.reset.submit_btn' | translate }}</button>
  </div>
</div>

<div class="row mt-2">
  <div class="col-12 justify-content-center d-flex">
    <a class="btn" routerLink="/auth/login">{{ 'auth.password.reset.cancel_btn' | translate }}</a>
  </div>
</div>
